export default __webpack_public_path__ + "static/gameplay-8dc768725a0ce553d125543c9a005730.png";